module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTQ0My44IDE4NS42YTE2IDE2IDAgMCAxIDQuMiAxMC44VjM1Mmg0ODBhMzIgMzIgMCAwIDEgMzIgMzJ2MjU2YTMyIDMyIDAgMCAxLTMyIDMySDQ0OHYxNTUuNmExNiAxNiAwIDAgMS0yNi44IDExLjhsLTM0NC4zLTMxNS42YTE2IDE2IDAgMCAxLTEtMjIuNmwxLTEgMzQ0LjMtMzE1LjZhMTYgMTYgMCAwIDEgMjIuNiAxeiIgZmlsbD0iIzAiIHAtaWQ9IjMyNjAiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Arrow-left-filled.svg
// module id = q1j3
// module chunks = 73